/* eslint-disable jsx-a11y/click-events-have-key-events */
import { faChevronDown, faChevronUp, faCircle, faEye, faEyeSlash, faPen, faTrash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Grid } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useLocales } from 'hook/LocalesProvider';
import { useUserInfo } from 'hook/UseUserInfo';
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState } from 'react';
import { NoteService } from 'services/NoteService';
import { NoteStatus } from 'utils/constants/noteStatus';
import { isLaboAdmin, isSuperAdmin } from 'utils/constants/roles';
import { capitalize } from 'utils/helpers/TextHelper';

const CONTENT_MAX_LENGTH = 200;

const useStyles = makeStyles((theme) => ({
  container: {
    border: `1px solid ${theme.palette.background.disabled}`,
    borderRadius: '5px',
    cursor: 'pointer',
    marginBottom: '10px'
  },
  noteContainer: {
    margin: '10px 0',
    overflow: 'auto',
    width: '570px'
  },
  title: {
    color: theme.palette.primary.dark
  },
  subTitle: {
    color: theme.palette.primary.main
  },
  unreadContainer: {
    backgroundColor: theme.palette.primary.light,
    border: `1px solid ${theme.palette.background.disabled}`,
    borderRadius: '5px',
    cursor: 'pointer',
    marginBottom: '10px',
    overflow: 'auto'
  },
  clickable: {
    cursor: 'pointer'
  }
}));

const NoteDisplay = ({
  noteData,
  handleDeleteNote,
  handleEditNote,
  getUnreadNotesNumber
}) => {
  const theme = useTheme();
  const [isOpen, setIsOpen] = useState(false);
  const [note, setNote] = useState(noteData);
  const [canBeOpened, setCanBeOpened] = useState(true);
  const [canEditOrDelete, setCanEditOrDelete] = useState(false);
  const classes = useStyles({ isOpen });
  const { role, accountRecid } = useUserInfo();
  const locales = useLocales();
  const locale = locales[locales.findIndex((loc) => loc.current)];
  const dateOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
  const timeOptions = { timeZone: "GMT", timeZoneName: "short" };

  const formatNoteContent = () => {
    if (canBeOpened) {
      return note.content.substring(0, CONTENT_MAX_LENGTH) + '...';
    } else {
      return note.content;
    }
  };

  useEffect(() => {
    if (accountRecid === noteData.author.recid) {
      setCanEditOrDelete(true);
    }
    if (isSuperAdmin(role)) {
      setCanEditOrDelete(true)
    }
  }, [noteData, role])

  useEffect(() => {
    setCanBeOpened(note.content.length > CONTENT_MAX_LENGTH);
  }, [note]);

  const handleClickOnNote = () => {
    if (canBeOpened) {
      setIsOpen(!isOpen);
    }

    if (note.isRead === false) {
      NoteService.readProducTestNote(note.recid)
        .then(() => {
          setNote({
            ...note,
            isRead: true
          });
          getUnreadNotesNumber();
        });
    }
  };

  const getFullDateFormatted = date => {
    const dateObject = new Date(date);
    const formattedDate = dateObject.toLocaleDateString(`${locale.languageCode}-${locale.countryCode}`, dateOptions);
    const formattedTime = dateObject.toLocaleTimeString(`${locale.languageCode}-${locale.countryCode}`, timeOptions);
    return `${capitalize(formattedDate)} ${formattedTime}`;
  }

  return (
    <Grid className={note.isRead ? classes.container : classes.unreadContainer} item key={note.id} onClick={handleClickOnNote}>
      <Grid className={classes.noteContainer} container direction="row" spacing={2}
        wrap="nowrap">
        <Grid item>
          <FontAwesomeIcon
            color={note.isRead && !canBeOpened ? theme.palette.background.paper : theme.palette.primary.main}
            icon={note.isRead ? isOpen ? faChevronUp : faChevronDown : faCircle}
          />
        </Grid>
        <Grid item>
          <Grid container direction="column" spacing={1}>
            <Grid item>
              <Grid container justifyContent="space-between" spacing={1}>
                <Grid item>
                  <Grid container spacing={1}>
                    <Grid item>
                      <Grid container direction="row" spacing={1} wrap="nowrap">
                        <Grid className={classes.title} item>
                          <h3 style={{ margin: '0' }}>{note.title}</h3>
                        </Grid>
                        {canEditOrDelete && <Grid className={classes.clickable} item onClick={() => handleEditNote(noteData)}>
                          <FontAwesomeIcon
                            color={theme.palette.success.main}
                            icon={faPen}
                          />
                        </Grid>}
                        {canEditOrDelete && <Grid className={classes.clickable} item onClick={() => handleDeleteNote(noteData.recid)}>
                          <FontAwesomeIcon
                            color={theme.palette.error.main}
                            icon={faTrash}
                          />
                        </Grid>}
                      </Grid>
                      <Grid container direction="column">
                        <Grid className={classes.subTitle} item>
                          <Grid container style={{ marginLeft: '0px' }}>
                            <Grid item>
                              {`${note.author.firstName} ${note.author.lastName} ${getFullDateFormatted(note.postDate)}`}
                            </Grid>
                            {isLaboAdmin(role) &&
                              <Grid item style={{ marginLeft: '5px' }} >
                                <FontAwesomeIcon
                                  color={note.status.id === NoteStatus.PRIVATE.id ? theme.palette.text.disabled : theme.palette.secondary.main}
                                  icon={note.status.id === NoteStatus.PRIVATE.id ? faEyeSlash : faEye}
                                />
                              </Grid>
                            }
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item style={{ marginLeft: '0px' }}>
              {isOpen ? note.content : formatNoteContent()}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default NoteDisplay;